
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/pam-tco-calculator",
      function () {
        return require("private-next-pages/tools/pam-tco-calculator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/pam-tco-calculator"])
      });
    }
  